import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock, DollarSign, Maximize, ArrowUp, ShieldCheck, RefreshCw } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function AdvantagesSection() {
  const {
    t
  } = useLanguage();
  const advantages = [{
    icon: Clock,
    title: t('adv.1.title'),
    description: t('adv.1.desc')
  }, {
    icon: DollarSign,
    title: t('adv.2.title'),
    description: t('adv.2.desc')
  }, {
    icon: Maximize,
    title: t('adv.3.title'),
    description: t('adv.3.desc')
  }, {
    icon: ArrowUp,
    title: t('adv.4.title'),
    description: t('adv.4.desc')
  }, {
    icon: ShieldCheck,
    title: t('adv.5.title'),
    description: t('adv.5.desc')
  }, {
    icon: RefreshCw,
    title: t('adv.6.title'),
    description: t('adv.6.desc')
  }];
  return <section className="w-full bg-gradient-to-br from-amber-dark to-amber py-20 sm:py-28" data-id="element-19">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20">
        <FadeIn data-id="element-21">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-22">
            <h2 className="text-3xl sm:text-4xl font-black text-navy-900 mb-6" data-id="element-23">
              {t('adv.title')}
            </h2>
          </div>
        </FadeIn>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-24">
          {advantages.map((adv, index) => {
          const Icon = adv.icon;
          return <FadeIn key={index} delay={0.1 * (index + 1)} data-id="element-25">
                <div className="bg-white/95 backdrop-blur-sm border-none rounded-xl p-8 h-full shadow-xl hover:-translate-y-1 transition-transform duration-300" data-id="element-26">
                  <div className="w-14 h-14 rounded-full bg-amber/20 flex items-center justify-center mb-6" data-id="element-27">
                    <Icon className="w-7 h-7 text-amber-dark" data-id="element-28" />
                  </div>
                  <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-29">
                    {adv.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-30">
                    {adv.description}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}